<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

// require('@/socket')

@Component({
  computed: {
    cammersAvailable () {
      const allCammers = this.$store.state.organization.cammersAvailable
      const cammerFiltered = allCammers.filter(this.filterCammer)
      return cammerFiltered
    },
    widget () {
      return this.$store.state.widget
    }
  },
  watch: {
    cammersAvailable: function () {
      this.setCammerAvailableByCategory()
    }
  }
})
export default class CammerAvailable extends Vue {
  filterCammer (cammer) {
    const cammerAvailable = cammer?.configs.find(config => config.type === 9)
    return (!cammerAvailable || cammerAvailable.value == "true")
  }

  async setCammerAvailableByCategory () {
    const cammersAvailable = this.cammersAvailable
    const cammerAvailableGroupByCategory = []

    for (let i = 0; i < cammersAvailable.length; i++) {
      const cammer = cammersAvailable[i]
      const categories = cammer.categories

      if (categories.length) {
        for (let j = 0; j < categories.length; j++) {
          const categoryId = categories[j].category_id
          const groupByCategorySeleted = cammerAvailableGroupByCategory.find((category) => category.categoryId === categoryId)

          if (!groupByCategorySeleted) {
            cammerAvailableGroupByCategory.push({
              categoryId,
              cammers: 1
            })
          } else if (groupByCategorySeleted) {
            groupByCategorySeleted.cammers += 1
          }
        }
      }
    }

    this.$store.commit('setCammersAvailableGroupByCategory', cammerAvailableGroupByCategory)
  }
}
</script>
